'use client'

import React, { useContext } from "react";

import * as S from "./HeroPrimary.styles";

import { Container, Row, Col, SpacerBase } from "../../../atoms/GridSystem";
import Button from "../../../atoms/Button/Button.component";
import Icon from "../../../atoms/Icon/Icon.component";
import { Paragraph, Heading } from "../../../atoms/Typography/Typography.component";
import ItemsGrouped from "../../../molecules/ItemsGrouped/ItemsGrouped.component";

import Image from "next/image";

import { SectionThemeContext } from '../../../../contexts/SectionTheme.context'

const HeroPrimary = ({ pretitle, title, paragraph, ctaPrimary, ctaSecondary, image }) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)

  return (
    <S.HeroPrimary colorScheme={selectedColorScheme}>
      <Container>
        <Row $reverse={['xs', 'sm', 'md']}>
          <Col xs={12} lg={5} $justify={"center"} $offsetRight={{ lg: 1 }}>
            <S.HeroPrimaryIconWrapper>
              <Icon name="leaf-green" useIconColor unlockedProportions />
            </S.HeroPrimaryIconWrapper>
            { pretitle ? (
              <>
                <Paragraph {...pretitle} />
                <SpacerBase xs={.5} />
              </>
            ) : null}
            { title ? (
              <>
                <Heading {...title} weight={'medium'} />
                <SpacerBase xs={2} />
              </>
            ) : null}
            { paragraph ? (
              <>
                <Paragraph typo={'paragraphMD'} content={paragraph} />
                <SpacerBase xs={3} lg={7} />
              </>
            ) : null}
            <>
            
            </>
            { ctaPrimary || ctaSecondary ? (
              <ItemsGrouped 
                direction={{ xs: "column", xl: "row" }} 
                space={{ xs: 16, xl: 24 }} 
                fullWidth={['xs', 'sm', 'md']}
                justify={{ xs: "center", xl: "flex-start" }}
              >
                {ctaPrimary ? <Button {...ctaPrimary} variant="primary" iconEnd="arrow-right" fullWidth/> : null}
                {ctaSecondary ? <Button {...ctaSecondary} variant="secondary" iconEnd="arrow-right" fullWidth/> : null}
              </ItemsGrouped>
            ) : null}
          </Col>
          <Col xs={12} lg={6} $justify={"center"}>
            <S.HeroPrimaryImageWrapper>
              <Image {...image} fill />
            </S.HeroPrimaryImageWrapper>
          </Col>
       </Row>
      </Container>
    </S.HeroPrimary>
  );
};

export default HeroPrimary;